<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sRound">Round Number </label>
                  <b-input id="sRound" type="text" placeholder="" v-model.trim="sRound"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sDrawNumber">Draw Number </label>
                  <b-input id="sDrawNumber" type="text" placeholder="" v-model.trim="sDrawNumber"></b-input>
                </b-col>
                <b-col sm="3">
                  <label for="sSettle">Draw Settle Status</label>
                  <b-form-select id="sSettle" :plain="false" v-model="sSettle">
                    <option :value="null">Please select</option>
                    <option v-for="s in settleOption" :key="`Result-${s.id}`" :value="s.id">{{ s.label }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Tickets</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(RoundNumber)="data">
                  #{{ data.item.RoundNumber }}
                </template>
                <template v-slot:cell(Action)="data">
                  <b-btn v-if="data.item.UnsettledTicket" variant="danger" class="btn-sm" @click="settleDraw(data.item.DrawNumber)">Settle Draw</b-btn>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'

export default {
  name: 'Lottery-draw-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'RoundNumber', label: 'Round No'},
        {key: 'DrawNumber', label: 'Draw Number'},
        {key: 'Name', label: 'Win Card'},
        {key: 'AddTime', label: 'Draw Time'},
        {key: 'Action', label: 'Action'}
      ],
      perPage: 50,
      currentPage: 1,
      rowCount: 0,
      settleOption: [
        {id: '1', label: 'All Settled Draw'},
        {id: '0', label: 'All Unsettled Draw'}
      ],
      sRound: '',
      sDrawNumber: '',
      sSettle: null
    }
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `size=${this.perPage}&page=${this.currentPage}&settle=${this.sSettle || ''}&round=${this.sRound}&drawNumber=${this.sDrawNumber}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/lottery/draw/list?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.draw
        this.rowCount = data.rowCount
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async settleDraw (drawNumber) {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/lottery/draw/settle', {
          drawNumber: drawNumber
        }, { headers: { 'Content-Type': 'application/json' } })
        this.search()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Draw Settled Successfully')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    checkAccessPrivilege (module, title = false) {
      return true
      // if (!module) return true
      // if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      // return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/lottery/draw/DrawTable.vue